export default "__VITE_ASSET__15dfb3ca__"